import { Box, Button, IconButton, Modal, Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import OTPInput from "react-otp-input";
// import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setShowalert } from "../../redux/actions/actions";
import Loader from "../../common/Loader";
import { English } from "../../constant/EnglishFallback";
import { useSelector } from "react-redux";
import { Getrequestcall } from "../../request/Getrequest";
import { IS_VALID_PHONE_RESET_CODE } from "../../constant/Apipath";

const VerifyPhoneModal = ({ onOpen, onClose, verifyPhoneObj, handledata }) => {
  const { loginData } = useSelector((state) => state?.main);
  const userId = loginData?.userInformation?.UserId;
  const [isSaving, setIsSaving] = useState(false);
  const [otp, setOtp] = useState("");
  const dispatch = useDispatch();
  const { multiLanguageData } = useSelector((state) => state?.main);

  const {
    TEXT_ALERT_RESET_CODE_TITLE = English?.Profile?.TEXT_ALERT_RESET_CODE_TITLE,
    TEXT_ALERT_RESET_CODE_DESC = English?.Profile?.TEXT_ALERT_RESET_CODE_DESC,
    TEXT_ALERT_VERIFICATION_CODE_TITLE = English?.Profile?.TEXT_ALERT_VERIFICATION_CODE_TITLE,
    TEXT_ALERT_VERIFICATION_CODE_DESC = English?.Profile?.TEXT_ALERT_VERIFICATION_CODE_DESC,
    TEXT_ALERT_PHONE_TITLE = English?.Profile?.TEXT_ALERT_PHONE_TITLE,
    TEXT_ALERT_PHONE_DESC = English?.Profile?.TEXT_ALERT_PHONE_DESC,
    TEXT_ALERT_RESEND_VERIFICATION_TITLE = English?.Profile?.TEXT_ALERT_RESEND_VERIFICATION_TITLE,
    TEXT_ALERT_RESEND_VERIFICATION_DESC = English?.Profile?.TEXT_ALERT_RESEND_VERIFICATION_DESC,
    TEXT_VERIFY_PHONE = English?.Profile?.TEXT_VERIFY_PHONE,
    TEXT_INSTRUCTION_1 = English?.Profile?.TEXT_INSTRUCTION_1,
    TEXT_INSTRUCTION_2 = English?.Profile?.TEXT_INSTRUCTION_2,
    TEXT_DIDNT_RECEIVE_CODE = English?.Profile?.TEXT_DIDNT_RECEIVE_CODE,
    BUTTON_VERIFY = English?.Profile?.BUTTON_VERIFY
  } = multiLanguageData?.Profile || {};

  function handleOtpChange(otp) {
    setOtp(otp);
  }

  const handelOtpErrorModal = () => {
    let alertObj = {
      showAlert: true,
      title: TEXT_ALERT_RESET_CODE_TITLE,
      text: TEXT_ALERT_RESET_CODE_DESC
    };
    dispatch(setShowalert(alertObj));
  };

  const handelIncorrectOtpModal = () => {
    let alertObj = {
      showAlert: true,
      text: TEXT_ALERT_VERIFICATION_CODE_TITLE,
      text2: TEXT_ALERT_VERIFICATION_CODE_DESC
    };
    dispatch(setShowalert(alertObj));
    let alertObj1 = {
      showAlert: true,
      text: TEXT_ALERT_VERIFICATION_CODE_TITLE,
      text2: TEXT_ALERT_VERIFICATION_CODE_DESC
    };
    dispatch(setShowalert(alertObj1));
  };

  const handelPhoneVerifiedModal = () => {
    let alertObj = {
      showAlert: true,
      title: TEXT_ALERT_PHONE_TITLE,
      text: `${verifyPhoneObj[0]?.verifyPhoneNo} ${TEXT_ALERT_PHONE_DESC}`
    };
    dispatch(setShowalert(alertObj));
    setTimeout(1000, onClose());
  };

  const handelCodeReceivedModal = () => {
    let alertObj = {
      showAlert: true,
      title: TEXT_ALERT_RESEND_VERIFICATION_TITLE,
      text: `${TEXT_ALERT_RESEND_VERIFICATION_DESC} ${verifyPhoneObj[0]?.verifyPhoneNo}`
    };
    dispatch(setShowalert(alertObj));
  };

  async function onVerifyClicked() {
    if (otp.length < 6) {
      handelOtpErrorModal();
      return false;
    } else {
      setIsSaving(true);
      try {
        let getOtpResponse = await Getrequestcall(
          `${IS_VALID_PHONE_RESET_CODE}/${userId}/${Number(verifyPhoneObj[0]?.UserPhoneId)}/${otp}`,
          loginData?.accessToken
        );

        if (getOtpResponse?.status == 200) {
          setIsSaving(false);
          handelPhoneVerifiedModal();
        } else {
          setIsSaving(false);
          handelIncorrectOtpModal();
        }
      } catch (error) {
        handelIncorrectOtpModal();
        setIsSaving(false);
      }
    }
  }

  async function sendMessage(item) {
    try {
      const smsObj = {
        userId: userId,
        phoneNo: Number(item[0].verifyPhoneNo),
        countryCode: item[0].verifyCountryCode
      };
      await handledata(smsObj);

      // if (getPhoneResponse) {
      handelCodeReceivedModal();
      // }
    } catch (error) {
      console.log("sendMessage-> Error While Sending Verify SMS: ", error);
    }
  }

  return (
    <>
      <Modal open={onOpen} onClose={onClose}>
        <Box className="user-modal-responsive" sx={{ p: 3 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between"
            }}>
            <Typography sx={{ fontWeight: "500" }} variant="h5">
              {TEXT_VERIFY_PHONE}
            </Typography>
            <Stack direction={"row"} sx={{ alignItems: "center" }}>
              <IconButton color="primary" onClick={onClose}>
                <CloseIcon />
              </IconButton>
            </Stack>
          </Box>

          <Stack sx={{ gap: 2 }} >
            <Typography variant="body2">
              {TEXT_INSTRUCTION_1} <b>{verifyPhoneObj?.verifyPhoneNo}</b> {TEXT_INSTRUCTION_2}
            </Typography>
            <Typography
              className="resendOtp"
              variant="body2"
              onClick={() => {
                sendMessage(verifyPhoneObj);
              }}>
              {TEXT_DIDNT_RECEIVE_CODE}
            </Typography>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 2
              }}>
              <OTPInput
                value={otp}
                isInputNum={true}
                onChange={handleOtpChange}
                numInputs={6}
                renderInput={(props) => <input {...props} />} // Add this prop
                inputStyle={{
                  width: "35px",
                  height: "35px",
                  margin: "5px",
                  fontSize: "1rem",
                  borderRadius: 4,
                  marginBottom: "20px",
                  border: "1px solid #484848"
                }}
              />
              <Button
                variant="contained"
                size="large"
                color="primary"
                onClick={onVerifyClicked}
                loading={isSaving}
                disabled={isSaving}>
                <b>{BUTTON_VERIFY}</b>
              </Button>
            </div>
          </Stack>
        </Box>
      </Modal>
    </>
  );
};
export default VerifyPhoneModal;

